function formatter(variable) {
  if (variable.pt_BR) {
    const formattedVariable = variable;

    formattedVariable["pt-BR"] = formattedVariable.pt_BR;
    delete formattedVariable.pt_BR;
  }
}

const ObjectIntlTranslator = ({
  variable,
  lang,
  style = null,
  firstWord = "",
}) => {
  const translate = () => {
    if (!variable) return "";

    formatter(variable);

    const variableLocales = Object.keys(variable);

    if (variableLocales.length === 1) {
      return variable[variableLocales[0]];
    }

    if (variable[lang]) {
      return variable[lang];
    }

    return variable[lang];
  };

  return (
    <span
      style={{ ...style }}
      dangerouslySetInnerHTML={{
        __html: firstWord
          ? translate()?.split(" ")?.slice(0, 1)?.join()
          : translate(),

      }}
    />
  );
};

export default ObjectIntlTranslator;
